import React, { useMemo } from "react";
import "./ExpiryDateCell.css";

interface ExpiryDateCellProps {
  expiryDate: string;
  shelfLife: number;
}

const ExpiryDateCell: React.FC<ExpiryDateCellProps> = ({ expiryDate, shelfLife }: ExpiryDateCellProps) => {
  
  const formattedDate = useMemo(() => {
    //timings will be coming is IST and will be shown as it is
    if (!expiryDate) return "";
    const date = new Date(expiryDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }, [expiryDate]);

  const remainingShelfLife = useMemo(() => {
    if (!expiryDate) return null;
    return Math.ceil((new Date(expiryDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  }, [expiryDate]);

  const remainingShelfLifePercentage = useMemo(() => {
    if (shelfLife === null || remainingShelfLife === null || shelfLife==0) return null;
    return (remainingShelfLife / shelfLife) * 100;
  }, [shelfLife, remainingShelfLife]);

  const cellStyle = useMemo(() => {
    let backgroundColor = "white";
    let borderColor = "transparent";
    let color = "black";

    if (remainingShelfLifePercentage !== null) {
      if (remainingShelfLifePercentage <= 30) {
        backgroundColor = "#FFFAF7";
        borderColor = "#fd5c63";
        color="#fd5c63";
      } else if (remainingShelfLifePercentage <= 70) {
        backgroundColor = "#FFF9EF";
        borderColor = "#CC911F";
        color = "#CC911F";
      } else {
        backgroundColor = "#F0FBFF";
        borderColor = "#17B4A3";
        color = "#17B4A3";
      }
    } else{
      backgroundColor = "#FFFAF7";
        borderColor = "#fd5c63";
        color="#fd5c63";
    }

    return {
      backgroundColor,
      borderColor,
      borderStyle: "solid",
      borderWidth: "1px",
      color
    };
  }, [remainingShelfLifePercentage]);

  return (
    <>
    
    {formattedDate&&<div className="ExpiryDateCell" style={cellStyle}>
      <span style={{ flex: 1 }}>{formattedDate}</span>
    </div>}
    </>
  );
};

export default ExpiryDateCell;
